import { render } from "./FlatCardNew.vue?vue&type=template&id=3cb038c3"
import script from "./FlatCardNew.vue?vue&type=script&lang=js"
export * from "./FlatCardNew.vue?vue&type=script&lang=js"

import "./FlatCardNew.vue?vue&type=style&index=0&id=3cb038c3&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__